export const handelOpenModalAddAddress = () => ({
    type: 'OPEN_MODAL_ADD_ADDRESS'
});
export const handelCloseModalAddAddress = () => ({
    type: 'CLOSE_MODAL_ADD_ADDRESS'
});

export const actionChangeInputsModalAddAddress = (name,value) => ({
    type: 'CHANGE_INPUTS_MODAL_ADDRESS',name,value
});
export const actionChangeLocationModalAddAddress = (lng,lat) => ({
    type: 'CHANGE_LOCATION_MODAL_ADD_ADDRESS',lng,lat
});
export const actionRefreshModalAddAddress = () => ({
    type: 'REFRESH_MODAL_ADD_ADDRESS'
});